import React from 'react';
import { ClipboardCheckIcon, CalendarIcon, GraduationCapIcon, FileTextIcon } from 'lucide-react';
export function ServicesOverview() {
  return <section id="services" className="py-16 bg-white" data-id="element-384" data-mp="3n7svfmcub61h">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-385" data-mp="39b5xbg95i9tz">
        <div className="text-center mb-16" data-id="element-386" data-mp="3e97hk4ibcf71">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-4" data-id="element-387" data-mp="3ea0cm87wtg9c">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-388" data-mp="5u78ksurlx96">
            Professional bookkeeping and tax services tailored to your business
            needs
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-389" data-mp="3s8gv0wf4wv7b">
          {/* Setup & Training */}
          <a href="#setup-training" className="block" data-id="element-390" data-mp="114e8ii5yjrx">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-391" data-mp="orq91835q7jz">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-392" data-mp="tji2prhm0tec">
                <GraduationCapIcon className="h-8 w-8" data-id="element-393" data-mp="10yspk0hfm7r5" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-394" data-mp="wwxmaqfxxkaq">
                Setup & Training
              </h3>
              <p className="text-gray-600" data-id="element-395" data-mp="1aokmh1d07cys">Feel in control from day one.</p>
            </div>
          </a>
          {/* Catch-up Bookkeeping */}
          <a href="#catchup-bookkeeping" className="block" data-id="element-396" data-mp="15v9bqp52mc1l">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-397" data-mp="1kknq6bni7jnu">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-398" data-mp="1fmdqbnqu3uvw">
                <ClipboardCheckIcon className="h-8 w-8" data-id="element-399" data-mp="1tkkegc5zegid" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-400" data-mp="1oo3gyrcw6psm">
                Catch-Up Bookkeeping
              </h3>
              <p className="text-gray-600" data-id="element-401" data-mp="3vfuuazkdi9n8">
                Get back on track with total peace of mind.
              </p>
            </div>
          </a>
          {/* Monthly Bookkeeping */}
          <a href="#monthly-bookkeeping" className="block" data-id="element-402" data-mp="1udwqxvxmkaf5">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-403" data-mp="1zby645rxjplc">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-404" data-mp="248x44zepsgot">
                <CalendarIcon className="h-8 w-8" data-id="element-405" data-mp="28cwgd5syotcd" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-406" data-mp="2d9mw1s0utmx9">
                Monthly Bookkeeping
              </h3>
              <p className="text-gray-600" data-id="element-407" data-mp="2i7wq1zauehha">
                Stay on top of your books- and your business.
              </p>
            </div>
          </a>
          {/* Tax Preparation */}
          <a href="#tax-preparation" className="block" data-id="element-408" data-mp="2rz13gukvdua0">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-409" data-mp="2w1fj75t8sdx2">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-410" data-mp="30zphhpa9jumw">
                <FileTextIcon className="h-8 w-8" data-id="element-411" data-mp="pdyk0l77bvmi" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-412" data-mp="kdaslyf29crr">
                Tax Preparation
              </h3>
              <p className="text-gray-600" data-id="element-413" data-mp="gd8pdktogbad">
                File with confidence- and keep more of what's yours.
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}